export const c_drawer__panel_TransitionProperty = {
  "name": "--pf-c-drawer__panel--TransitionProperty",
  "value": "margin, transform, box-shadow",
  "var": "var(--pf-c-drawer__panel--TransitionProperty)"
};
export default c_drawer__panel_TransitionProperty;